import TranslationsService from '@core/services/translations.service';
import { TranslationReportService } from './translation-report.service';

export default class FakeTranslationsService extends TranslationsService {
  constructor(public translationReportService: TranslationReportService) {
    super();
  }
  async getTranslations(language: string = null) {
    const res = await super.getTranslations(language);
    this.translationReportService.setMessages(res.data);
    return res;
  }
}
